var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-sizes":_vm.Pagesize,"page-size":_vm.currentSize,"layout":_vm.layout,"total":_vm.dataTotal,"pager-count":_vm.pagecount},on:{"size-change":_vm.handleSize,"current-change":_vm.handleCurent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a70ffcf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paging/paging.vue
// module id = igl2
// module chunks = 16